export const planningSeelingPath = (index, keyName) => {
  return {
    PLANNING_SELLING: `[${index}].planSelling[${keyName}]`,
    PLANNING_SELLING_TOTALPWS: `[${index}].totalPWS`,
    // PLANNING_SELLING: `${index}.planSelling[${chIndex}][${keyName}]`,
  };
};

export const FPKeysPath = (index, keyName) => {
  return {
    FPKEYS: `[${index}][${keyName}].value`,
    FP_SALES_UNIT: `[${index}].fpSalesUnits`,
    FP_SALES_VALUES: `[${index}].fpSalesValue`,
  };
};

export const TerminalPath = (index, keyName) => {
  return {
    TERMINAL_KEYS: `[${index}][${keyName}].value`,
    TERMINAL_UNITS: `[${index}].terminalUnits`,
    TERMINAL_BUY_UNITS: `[${index}].terminalUkBuyUnits`,
    TERMINAL_TOTAL_SALES_VALUE: `[${index}].totalSalesValue`,
  };
};

export const mdPath = (index, keyName) => {
  return {
    MD_PERCENTAGE: `[${index}][${keyName}].value`,
  };
};
export const marketPlace = (index, keyName) => {
  return {
    UNIT_MARKET_PLACE: `[${index}][${keyName}].value`,
    RATIO: `[${index}][unitMarketPlace].ratio`,
  };
};

export const outlet = (index, keyName) => {
  return {
    UNIT_OUTLET: `[${index}][${keyName}].value`,
    RATIO: `[${index}][unitOutlate].ratio`,
  };
};
